export const coachingKeys = {
  all: ['coaching'] as const,
  today: (date?: string) => ['coaching', 'today', date ?? 'today'] as const,
  learnerToday: (id: number, date?: string) =>
    ['coaching', 'learner', id, 'today', date ?? 'today'] as const,
  designatedReviews: (id: number) => ['coaching', 'learner', id, 'designated-reviews'] as const,
  designatedReviewMutation: (id: number, lessonId: number) =>
    ['coaching', 'learner', id, 'designated-review-mutation', lessonId] as const,
  classes: () => ['coaching', 'classes', 'today'] as const,
  roster: (timeslotId: number) => ['coaching', 'classes', timeslotId, 'roster'] as const,
  handheldGradingSummary: () => ['coaching', 'classes', 'handheld-grading-summary'] as const,
  rosterSearch: (query: string) => ['coaching', 'classes', 'roster-search', query] as const,
  library: (id: number, range: string) =>
    ['coaching', 'learner', id, 'library', range] as const,
  lessonDetailPath: (id: number, lessonId: number) =>
    ['coaching', 'learner', id, 'lesson', lessonId, 'path'] as const,
  lessonDetail: (id: number, lessonId: number, courseId = 0, moduleId = 0) =>
    [...coachingKeys.lessonDetailPath(id, lessonId), courseId, moduleId, 'detail'] as const,
  reviewNote: (id: number, lessonId: number, learningAttemptId?: number | null) =>
    ['coaching', 'learner', id, 'lesson', lessonId, 'review-note', learningAttemptId ?? 'progress'] as const,
  reviewNoteSourceAvailability: (id: number, lessonId: number, learningAttemptId?: number | null) =>
    ['coaching', 'learner', id, 'lesson', lessonId, 'review-note-source-availability', learningAttemptId ?? 'progress'] as const,
  reviewNoteScope: (id: number, lessonId: number, learningAttemptId?: number | null) =>
    ['coaching', 'learner', id, 'lesson', lessonId, 'review-note-scope', learningAttemptId ?? 'progress'] as const,
  reviewNoteDetail: (id: number, setId: number) =>
    ['coaching', 'learner', id, 'review-note', setId, 'detail'] as const,
  reviewNotePool: (id: number, setId: number) =>
    ['coaching', 'learner', id, 'review-note', setId, 'pool'] as const,
  reviewNotePrintQuizIds: (id: number, setId: number) =>
    ['coaching', 'learner', id, 'review-note', setId, 'print-quiz-ids'] as const,
  guideForLesson: (id: number, lessonId: number) =>
    ['coaching', 'learner', id, 'guide', lessonId] as const,
  guide: (id: number, lessonId: number, learningAttemptId?: number | null) =>
    [...coachingKeys.guideForLesson(id, lessonId), learningAttemptId ?? 'progress'] as const,
  workbookGrades: (id: number, lessonId: number) =>
    ['coaching', 'learner', id, 'workbook-grade', lessonId] as const,
  tests: (id: number) => ['coaching', 'learner', id, 'tests'] as const,
  testDetail: (id: number, testId: number) =>
    ['coaching', 'learner', id, 'test', testId, 'detail'] as const,
  testEnsure: (id: number, kind: string, chapterOrdinal: number, scopeContentId: number, force: boolean) =>
    ['coaching', 'learner', id, 'test-ensure', kind, chapterOrdinal, scopeContentId, force] as const,
  // 단원평가 특강
  unitAssessmentCatalog: (includeInactive: boolean) =>
    ['coaching', 'ua-catalog', includeInactive] as const,
  unitAssessments: (id: number) => ['coaching', 'learner', id, 'unit-assessments'] as const,
  unitAssessmentDetail: (id: number, uaId: number) =>
    ['coaching', 'learner', id, 'unit-assessment', uaId, 'detail'] as const,
  cumulativeAssessment: (id: number, assessmentId: number) =>
    ['coaching', 'learner', id, 'cumulative-assessment', assessmentId] as const,
}
